import baseApi from "../api/baseApi";

const demoSessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createDemoSessionRequest: builder.mutation({
      query: (body) => ({
        url: "/demosession/createDemoSessionRequest",
        method: "POST",
        body,
      }),
      invalidatesTags: ["DemoSessions"],
    }),
    getStudentDemoSessionRequests: builder.query({
      query: () => ({
        url: "/demosession/getStudentDemoSessionRequests",
        method: "GET",
      }),
      providesTags: ["DemoSessions"],
    }),
  }),
});

export const {
  useCreateDemoSessionRequestMutation,
  useGetStudentDemoSessionRequestsQuery,
} = demoSessionApi;

export default demoSessionApi;
